import Vue from "vue";
import VueRouter from "vue-router";
import WaitView from "../views/WaitView.vue";
import FinishView from "../views/FinishView.vue";
import MentionsView from "../views/MentionsView.vue";
import CloseView from "../views/CloseView.vue";
import LaterView from "../views/LaterView.vue";
import ContactView from "../views/ContactView.vue";
import updateView from "@/views/UpdateView.vue";
import statueView from "@/views/StatueView.vue";
Vue.use(VueRouter);



// Composant dynamique qui gère le changement à minuit
const DynamicHomeComponent = {
  data() {
    return {
      isAfterMidnight: false
    }
  },
  created() {
    this.checkMidnight();
    // Vérifier toutes les minutes
    this.interval = setInterval(this.checkMidnight, 60000);
  },
  beforeDestroy() {
    // Nettoyer l'intervalle quand le composant est détruit
    clearInterval(this.interval);
  },
  methods: {

      checkMidnight() {
        const now = new Date();
        const startDate = new Date('2025-05-19T00:00:00');
        this.isAfterMidnight = now >= startDate;
      }
  },
  render(h) {
    return h(this.isAfterMidnight ? FinishView : WaitView);
  }
};

const routes = [
  {
    path: "/",
    name: "home",
    // component: HomeView,
    component: DynamicHomeComponent,
  },
  {
    path: "/home",
    name: "home",
    component: FinishView,
  },
  {
    path: "/update",
    name: "update",
    component: updateView,
  },
  {
    path: "/status/:_id/:uid",
    name: "update",
    component: statueView,
  },
  {
    path: "/done",
    name: "done",
    component: FinishView,
  },
  {
    path: "/vote",
    name: "vote",
    component: FinishView,
  },
  {
    path: "/voteok",
    name: "voteok",
    component: FinishView,
  },
  {
    path: "/form",
    name: "form",
    component: FinishView,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/close",
    name: "close",
    component: CloseView,
  },
  {
    path: "/later",
    name: "later",
    component: LaterView,
  },
  {
    path: "/wait",
    name: "wait",
    component: WaitView,
  },
  {
    path: "/finish",
    name: "finish",
    component: FinishView,
  },
  {
    path: "/mentions",
    name: "mentions",
    component: MentionsView,
  },
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
